import { createSlice } from '@reduxjs/toolkit';
import { apiHolder as api } from 'api';
const storeApi = api.api.getDataStoreApi();
const changeRemindByLocal = (originData, key) => {
    if (originData.type === 'click') {
        Object.keys(originData).forEach(_ => {
            if (['isShow', 'type'].indexOf(_) === -1) {
                changeRemindByLocal(originData[_], `${key}.${_}`);
            }
        });
        const { data, suc } = storeApi.getSync(key);
        if (suc && data === 'true') {
            originData.isShow = false;
            return false;
        }
        else {
            originData.isShow = true;
            return true;
        }
    }
    else if (originData.type === 'auto') {
        let isShow = Object.keys(originData).some(_ => {
            if (['isShow', 'type'].indexOf(_) === -1) {
                return changeRemindByLocal(originData[_], `${key}.${_}`);
            }
            else {
                return false;
            }
        });
        originData.isShow = isShow;
        return isShow;
    }
    return false;
};
const getInitialState = () => {
    const initState = {
        guideQueue: [],
        avatarRemind: {
            type: 'auto',
            isShow: true,
            mailSettingRemind: {
                type: 'click',
                isShow: true,
            },
        },
    };
    const remind = ['avatarRemind'];
    remind.forEach((_) => {
        const onRemind = initState[_];
        changeRemindByLocal(onRemind, _);
    });
    return initState;
};
const hollowOutGuideSlice = createSlice({
    name: 'hollowOutGuideReducer',
    initialState: getInitialState(),
    reducers: {
        doAddGuide: (state, action) => {
            const { step, guideId, type, noneUserRelated } = action.payload;
            let sort = 0;
            if (type === '1') {
                sort = 100;
            }
            else if (type === '2') {
                sort = 10;
            }
            else if (type === '3') {
                sort = 1;
            }
            for (let i = 0; i < state.guideQueue.length; i++) {
                let onGuide = state.guideQueue[i];
                if (onGuide.guideId === guideId) {
                    if (!onGuide.steps[step - 1]) {
                        onGuide.steps[step - 1] = {
                            step,
                            show: onGuide.onStep === step ? true : false,
                        };
                    }
                    else {
                        console.log('guide', '当前步骤已存在');
                    }
                    return;
                }
            }
            let guide = {
                guideId,
                onStep: 1,
                sort,
                noneUserRelated: !!noneUserRelated,
                steps: [],
            };
            guide.steps[step - 1] = {
                step,
                show: step == 1 ? true : false,
            };
            if (sort === 0 || state.guideQueue.length === 0 || sort <= state.guideQueue[state.guideQueue.length - 1].sort) {
                state.guideQueue.push(guide);
                return;
            }
            for (let i = 0; i < state.guideQueue.length; i++) {
                let onGuide = state.guideQueue[i];
                if ((sort = onGuide.sort)) {
                    state.guideQueue.splice(i + 1, 0, guide);
                    return;
                }
                else if (sort > onGuide.sort) {
                    state.guideQueue.splice(i, 0, guide);
                    return;
                }
            }
        },
        doDeleteGuide: (state, action) => {
            const { step, guideId } = action.payload;
            for (let i = 0; i < state.guideQueue.length; i++) {
                let onGuide = state.guideQueue[i];
                if (onGuide.guideId === guideId) {
                    onGuide.steps[step - 1] = undefined;
                    if (onGuide.steps.every(step => step === undefined)) {
                        state.guideQueue.splice(i, 1);
                    }
                    return;
                }
            }
        },
        doNextStep: (state, action) => {
            const { step, guideId } = action.payload;
            if (!state.guideQueue[0] || state.guideQueue[0].guideId !== guideId) {
                return;
            }
            let onStep = state.guideQueue[0].steps[step - 1];
            let nextStep = state.guideQueue[0].steps[step];
            if (onStep) {
                onStep.show = false;
                state.guideQueue[0].onStep = step + 1;
            }
            if (step >= state.guideQueue[0].steps.length) {
                state.guideQueue.shift();
            }
            else if (nextStep) {
                nextStep.show = true;
            }
        },
        doSkip: (state, action) => {
            const { guideId } = action.payload;
            if (!state.guideQueue[0] || state.guideQueue[0].guideId !== guideId) {
                return;
            }
            state.guideQueue.shift();
        },
        changeRemind: (state, action) => {
            const key = action.payload.split('.')[0];
            let newState = getInitialState();
            state[key] = newState[key];
        },
    },
});
export const { actions } = hollowOutGuideSlice;
export default hollowOutGuideSlice.reducer;
